import React from "react";
import { InspectionPointStatus, fieldValidation } from "../../../../../amorg-common";
import { TextAreaField } from "../../../../../designSystem/formField/textArea/TextAreaField";
import { Flex } from "../../../../../designSystem/compositeComponents/FlexHelpers";
import { Icon } from '../../../../../designSystem/icons/Icons';
import { FancyRadioButton } from "../../../../../designSystem/inputs/FancyRadioButton";
import { Span12 } from "../../../../../designSystem/typography/Body";

type InspectionStatePanelProps = {
    status:InspectionPointStatus,
    comment:string,
    onChange:(status:InspectionPointStatus, comment:string) => void
}
export function InspectionStatePanel(props:InspectionStatePanelProps):JSX.Element
{
    
    const validComment = props.comment ? fieldValidation.facilityInspection.comment(props.comment) : true;

    return (
        <Flex flexDirection="column" gap={16}>

            <Flex justifyContent="space-between" gap={32}>
                    <FancyRadioButton id="radio_pending"
                        name="status"
                        checked={props.status === 'pending'}
                        checkedStyle="neutral"
                        value="pending"
                        style={{flex: 1}}
                        onChange={(value) => props.onChange(value as InspectionPointStatus, props.comment)}>

                        <Flex flexDirection="column" alignItems="center" gap={4}>
                            <Icon name="clock" />
                            <Span12>Ikke kontrolleret</Span12>
                        </Flex>

                    </FancyRadioButton>

                    <FancyRadioButton id="radio_passed"
                        name="status"
                        checked={props.status === 'passed'}
                        checkedStyle="success"
                        value="passed"
                        style={{flex: 1}}
                        onChange={(value) => props.onChange(value as InspectionPointStatus, props.comment)}>

                        <Flex flexDirection="column" alignItems="center" gap={4}>
                            <Icon name="status_ok" />
                            <Span12>Godkendt</Span12>
                        </Flex>
                        
                    </FancyRadioButton>

                    <FancyRadioButton id="radio_failed"
                        name="status"
                        checked={props.status === 'failed'}
                        checkedStyle="failure"
                        value="failed"
                        style={{flex: 1}}
                        onChange={(value) => props.onChange(value as InspectionPointStatus, props.comment)}>

                        <Flex flexDirection="column" alignItems="center" gap={4}>
                            <Icon name="status_error" />
                            <Span12>Ikke godkendt</Span12>
                        </Flex>
                        
                    </FancyRadioButton>
            </Flex>

            <TextAreaField 
                label='Bemærkning   '
                value={props.comment}
                onChange={(value) => props.onChange(props.status, value)}
                errorMessage={validComment ? '' : `Ugyldig tekst. Må maks indeholde 1000 tegn (${props.comment.length}) `}
                minRows={3}
            />
        </Flex>
    );
}